/**
 * Story limits the composer and the server both read, in one place.
 *
 * A SEPARATE ENTRY POINT, deliberately. The barrel pulls in axios, sharp and
 * xstate, so a browser importing these numbers through it would drag the
 * whole publish stack into the client bundle. This module imports nothing at
 * all, which is what makes `@dialogueconsulting/ig-content-publishing/constants`
 * safe for the composer to read.
 *
 * The two Instagram story ceilings are OURS, not Meta's. Keeping them out of
 * `graph/transport.ts`, where Meta's real limits live, is what stops a Sked
 * product decision later being argued for as something Instagram requires. The
 * Facebook story limits at the end are Meta's.
 */

/**
 * Sked's own ceiling on how many stories one post may publish, SKE-4567.
 *
 * Deliberately NOT in `graph/transport.ts` beside `IG_CAROUSEL_MAX_CHILDREN`.
 * Those are META's numbers and are defensible as platform constraints; this one is
 * ours, and mixing them is how a Sked limit later gets argued for as something
 * Instagram requires. Meta imposes no story-set limit because it has no story-set
 * concept: each story is an independent publish.
 *
 * It exists to bound a runaway rather than to express a product rule.
 *
 * TEN, matching Meta's carousel ceiling, because that is what the router already
 * enforces (`isPostApiExpressible` refuses any post over `CAROUSEL_MAX_CHILDREN`)
 * and Sked has not chosen a higher story limit. The number agreeing with the
 * carousel one is a coincidence of that decision, NOT evidence that Instagram caps
 * a story set - it does not, because it has no story-set concept. It was 50 while
 * the router's check made it unreachable, which meant a story post over ten heard
 * about carousels and this constant bounded nothing.
 */
export const MAX_STORY_SET_ITEMS = 10;

/**
 * The longest story chain a PHONE-track post may carry, SKE-4567.
 *
 * The cap of three is a PHONE limit. A device publishes a story set as one
 * message and one outcome, so a long chain is a long time on a device that can
 * fail part way with nothing recorded. The API track has neither property: one
 * job creates a container per story and records each publish as it lands, so
 * the cap protects nothing there.
 *
 * Note the cap takes the POST, not just the account. A story carrying a sticker
 * still falls back to a device even on an API-capable account, and that post is
 * still capped.
 *
 * A PHONE-FARM FACT WITH AN EXPIRY. It describes the device fleet, not
 * Instagram, so it is deleted outright at M6 along with the phone track itself.
 */
export const PHONE_STORY_CHAIN_MAX = 3;

/** Meta's Page Stories API limits, https://developers.facebook.com/docs/page-stories-api. */
export const FACEBOOK_STORY_VIDEO_MIN_SECONDS = 3;
export const FACEBOOK_STORY_VIDEO_MAX_SECONDS = 60;
export const FACEBOOK_STORY_VIDEO_MIN_WIDTH = 540;
export const FACEBOOK_STORY_VIDEO_MIN_HEIGHT = 960;
export const FACEBOOK_STORY_PHOTO_MAX_BYTES = 10e6;

/** The composer's 9:16 bounds, which are also its reel bounds. */
export const FACEBOOK_STORY_COMPOSER_ASPECT_RATIO = { min: 0.55, max: 0.57 };
/** The server's 9:16 bounds, shared with its reel validation. */
export const FACEBOOK_STORY_SERVER_ASPECT_RATIO = { min: 0.55, max: 0.58 };
